module.exports = __webpack_public_path__ + "static/media/retox-music.92d2c5e9.png";